import React, { useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import Title from 'components/Title'
import UserList from 'components/Table/BasicTable'

import { Input, message, DatePicker } from 'antd';
import { useDispatch, useSelector } from 'react-redux'
import { DataGetAction } from 'redux/actions/http';
import IntlMessages from "util/IntlMessages"
import SelectFilter from 'components/Filters/CallFilters'
import { intlPlaceholder } from "util/intlPlaceholder"
import PatientHealthReport from './components/PatientHealthReport'
import SimpleModal from 'components/Modal/SimpleModal'
import moment from 'moment'
import logo from 'assets/logo/logo.png'
import PatientReport from './components/PatientReport'
const { RangePicker } = DatePicker;
const Index = () => {


    const dispatch = useDispatch()

    const reportProps = useSelector(state => state.report)
    const { textMessage, apiFail, reportList, patientModelVisible, patientDetails, accountManagersList,reportRead,reportListSpinner } = reportProps
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));




    const fetchManagersList = () => {
        dispatch(DataGetAction('getManagerDropdown', '', 'gettingManagerDropdown'))

    }



    useEffect(fetchManagersList, [])

    const {role} = userInfo
    console.log(patientDetails)


    const fetchRevenueReportList = () => {
        dispatch(DataGetAction('getReportList', { query: "all" }, 'gettingReportListSpinner'));
        // dispatch(DataGetAction('getAccountManager', { query: "all" }, 'gettingAccountManager'));

    }
    useEffect(fetchRevenueReportList, [])

    if(reportRead){
        dispatch(DataGetAction('getReportList', { query: "all" }, 'gettingReportListSpinner'));
        dispatch({
            type : 'resetRportList'
        })
    }



    const renderRedFlagTrend = (redFlagCount, lastReportRedFlagCount) => {
        if (parseInt(lastReportRedFlagCount) === 0 || parseInt(lastReportRedFlagCount) === parseInt(redFlagCount)) {
            return <span className="zero-flag" >No change</span>
        }

        else if (parseInt(lastReportRedFlagCount) < parseInt(redFlagCount)) {
            return <span className="icon icon-long-arrow-up" style={{ color: '#F5232D', fontSize: '25px' }}></span>
        }
        else if (parseInt(lastReportRedFlagCount) > parseInt(redFlagCount)) {
            return <span className="icon icon-long-arrow-down" style={{ color: '#3FD4A2', fontSize: '25px' }}></span>
        }


    }


    const columns = [
        {
            title: <IntlMessages id="report.id" />,
            render: record => <span>{record.reportId}</span>,
            key: "userId"
        },
        {
            title: <IntlMessages id="report.patientName" />,
            render: record => <span>{record.patientName || record.fullName}</span>,
            key: "firstName"
        },
        {
            title: <IntlMessages id="report.email" />,
            render: record => <span>{record.email}</span>,
            key: "email"
        },
        {
            title: <IntlMessages id="report.accountManager" />,
            render: record => <span>{record.accountManagerName || record.accountManagerFullName}</span>,
            key: "email"
        },
        {
            title: <IntlMessages id="report.filledBy" />,
            render: record => <span>{record.filledBy}</span>,
            key: "lastName"
        },

        {
            title: <IntlMessages id="report.dateTime" />,
            render: record => <span>{moment(record.createdAt).format('Do MMM YYYY')}</span>,
            key: "phone"
        },
        {
            title: <IntlMessages id="report.redFlags" />,
            render: record => parseInt(record.redFlagCount) > 0 ? <span className="red-flag">{record.redFlagCount}</span> : <span className="blue-flag">{record.redFlagCount}</span>,
            key: "redFlags"
        },
        {
            title: <IntlMessages id="report.redFlagsTrend" />,
            render: record => <div className="gx-text-center">{renderRedFlagTrend(record.redFlagCount, record.lastReportRedFlagCount)}</div>,
            key: "redFlags"
        },
        {
            title: <IntlMessages id="report.report" />,
            render: (record,index) => <PatientHealthReport record={record} />,
            key: "action"
        },
    ];

    if (apiFail) {
        message.error(textMessage)
        dispatch({
            type: 'resetRportList'
        })
    }

    const renderHeader = () => {
        return <div className="gx-d-flex gx-justify-content-between gx-align-items-center">
            <img src={logo} alt="" />
            <h4 className="gx-font-sans-bold gx-blue-font gx-mb-0"><IntlMessages id="report.reportModal.patientHealthReport" /></h4>
            <div>
                <span style={{ fontSize: '14px', color: '#707070' }}><IntlMessages id="report.reportModal.reportDate" /></span>
                <span style={{ fontSize: '14px' }} className="gx-blue-font">{moment().format('Do MMM YYYY')}</span>
            </div>
        </div>
    }


    const onChange = (dates, dateStrings) => {
        dispatch(DataGetAction('getReportList', { query: "search", key: "date", startDate: dates[0], endDate: dates[1] }, 'gettingReportList'));
    }
    return (
        <Layout>

            <div className="gx-d-flex gx-flex-row gx-justify-content-between">
                <div className="gx-mb-2 gx-mb   -md-0">
                    <Title title={<IntlMessages id="report.reports" />} />
                </div>
                <div className="gx-d-flex gx-flex row">
                    <div className=" gx-mb-3 gx-mb-md-0 gx-mr-3" style={{width : '180px'}} >
                        <RangePicker onChange={onChange} />
                    </div>
                    <div className="gx-mr-3 gx-mb-3 gx-mb-md-0">
                        <SelectFilter placeholder="Filter by account manager" isShowingAll={true} apiName="getReportList" searchKey="searchByAccountManager" options={accountManagersList} ItemValue="_id" label="fullName" />
                    </div>

                    <div className="gx-my-0 gx-mr-3" style={{ width: '200px' }}>
                        <Input.Search
                            showSearch
                            placeholder={intlPlaceholder('report.filter.email')}
                            filterOption={false}
                            onChange={(e) => dispatch(DataGetAction('getReportList', { name: e.target.value }, ''))}
                        />
                    </div>
                  {role === 'superAdmin' &&  <div className=" gx-mb-3 gx-mb-md-0">
                        <SelectFilter placeholder="Read/UnRead" isShowingAll={true} apiName="getReportList" searchKey="readStatus" options={
                            [
                                { status: "read", "label": "Read" },
                                { status: "unRead", "label": "Un Read" },
                            ]
                        } ItemValue="status" label="label" />
                    </div>}

                </div>

            </div>


            <UserList 
            rowClassName={(record, index) =>{
                if(record.readStatus === 'unRead' && role === 'superAdmin'){
                    return 'table-row-bold'
                }
                

            }}
            loading={reportListSpinner}
            data={reportListSpinner ? [] : reportList} columns={columns} />

          {patientModelVisible &&  <SimpleModal
                title={renderHeader()}
                modalFor="patientReport_Modal"
                visible={patientModelVisible}
                width={750}
                closable={false}
                maskClosable={true}
                className="patientReportModal"
            >

                <PatientReport patientDetails />


            </SimpleModal>}
        </Layout>
    )
}

export default Index
